import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import IconClose from "../../Resources/svg/Icons/IconClose";
import { modalSteps } from "../../Store/simulate/actions";

const ModalFiltering = ({
  children,
  className,
  variant,
}: any) => {
  const [isOpen, setIsOpen] = useState<any>(false);
  const dispatch = useDispatch()
  const modalStepState = useSelector((state: any) => state.simulate.policy.modalSteps);

  const handleClose = () => {
    setIsOpen(false);
    dispatch(modalSteps(false))
    document.body.style.overflow = "auto";
  };

  const handleOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  useEffect(() => {
    if (modalStepState) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [modalStepState]);

  return (
    <div
      className={
        "modal-filtering" +
        (isOpen ? " is-open" : "") +
        (className ? " " + className : "")
      }
    >
      <div className={"modal-filtering__box"}>
        {
          !variant &&(
            <div className="modal-filtering__close" onClick={handleClose}>
              <IconClose />
            </div>
          )
        }
        <div className="modal-filtering__body">
          <div className="wrap">
            <div className="modal-filtering__inner">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalFiltering;
